import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import type { FunctionComponent } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// no direct mutation in parent; handled inside AuthenticateEmail
import { AuthenticateEmail } from "./AuthenticateEmail";
import ConfirmResetForm from "./ConfirmResetForm";

type Props = {
  closeModal: () => void;
};

export const ForgotPassword: FunctionComponent<Props> = ({ closeModal }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState<number>(1);
  const [email, setEmail] = useState<string>("");
  const [feedback, setFeedback] = useState<string>("");

  const setUrlStep = (s: number) => {
    const url = new URL(window.location.href);
    if (s === 1) url.searchParams.delete("step");
    else url.searchParams.set("step", String(s));
    window.history.pushState({}, "", url.toString());
  };

  const handleEmailSuccess = (nextEmail: string, info?: string) => {
    setEmail(nextEmail);
    if (info) setFeedback(info);
    setStep(2);
    setUrlStep(2);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const stepParam = urlParams.get("step");
    if (stepParam === "2") {
      setStep(2);
    }
  }, []);

  return (
    <>
      {step === 1 && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          marginBottom={1}
          flexWrap="wrap"
        >
          <Typography
            variant="subtitle1"
            component="h2"
            sx={{
              flex: 1,
              textAlign: "center",
              marginRight: "50px",
              textTransform: "capitalize",
              color: "#00244e",
              fontWeight: "bold",
            }}
          >
            {t("common.form.input.set-new-password")}
          </Typography>

          {feedback && (
            <Alert severity="error">
              <AlertTitle>{feedback}</AlertTitle>
            </Alert>
          )}

          <AuthenticateEmail
            value={email}
            identifier="email"
            onSuccess={handleEmailSuccess}
            remark={t("login.code-will-sent-to-email")}
          />
        </Box>
      )}

      {step === 2 && (
        <ConfirmResetForm
          email={email}
          onSuccess={() => {
            setFeedback("");
            setStep(1);
            setUrlStep(1);
            closeModal();
          }}
        />
      )}
    </>
  );
};
